import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { useState } from 'react';
import { PrevArrow, NextArrow } from './utills/ImageCarousel';
import '../styling/styling.css'



//when your box is horizontal 
//alignItems is for vertical
//justifyContent is for horizontal

//font families are Oswald and Futura

const carouselStyle = {
    width: { xs: '75%', sm: '45%' }, // responsive: take full width on mobile, ~45% on larger screens
    margin: '0 auto', // Center the carousel horizontally
    textAlign: 'center', // Ensure the carousel is centered
};

const imageStyle = {
    width: '100%', // Make the image responsive
    height: 'auto', // Maintain aspect ratio
    maxWidth: { xs: '300px', sm: '500px' }, // Limit image size on mobile
    objectFit: 'cover', // Ensure the image fits nicely within the container
    margin: '0 auto', // Center the image horizontally
};

const ImageCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow onClick={() => setCurrentSlide(currentSlide + 1)} />, // Custom next arrow component
        prevArrow: <PrevArrow onClick={() => setCurrentSlide(currentSlide - 1)} />, // Custom previous arrow component
        afterChange: (current) => setCurrentSlide(current),
    };

    return (
        <Box sx={carouselStyle}>
            <Slider {...settings}>
                <div>
                    <img
                        className="aboutCarouselImage"
                        src="https://wild-photos.s3.amazonaws.com/WildRoom2.JPG"
                        alt="Wild Room 2"
                        style={imageStyle} // Apply responsive image styling
                    />
                </div>
                <div>
                    <img
                        className="aboutCarouselImage"
                        src="https://wild-photos.s3.amazonaws.com/WildRoom3.JPG"
                        alt="Wild Room 3"
                        style={imageStyle} // Apply responsive image styling
                    />
                </div>
                <div>
                    <img
                        className="aboutCarouselImage"
                        src="https://wild-photos.s3.amazonaws.com/WildRoom1.JPG"
                        alt="Wild Room 1"
                        style={imageStyle} // Apply responsive image styling
                    />
                </div>
                <div>
                    <img
                        className="aboutCarouselImage"
                        src="https://wild-photos.s3.amazonaws.com/WildRoom4.JPG"
                        alt="Wild Room 4"
                        style={imageStyle} // Apply responsive image styling
                    />
                </div>
            </Slider>
        </Box>
    );
};


const aboutParentContainerStyle = {
    width: '100%',
    minHeight: '75vh',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    overflowX: 'hidden', // Prevent horizontal scrolling
};

const headingBoxStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    borderRadius: '50px',
    overflow: 'hidden',
    marginBottom: '3%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    justifyContent: 'center',
    padding: '1rem', // Add padding for better spacing
};

const contentBoxStyle = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on mobile, horizontally on larger screens
    width: '100%',
    alignItems: 'flex-start',
    marginBottom: '8%',
    minHeight: '300px',
    padding: { xs: '1rem', sm: '4%' }, // consistent padding on both sides
    gap: { xs: '1rem', sm: '2rem' }, // space between children (carousel and text)
    boxSizing: 'border-box',
};

const textContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: { xs: '100%', sm: '55%' }, // Full width on mobile, ~55% on larger screens
    margin: { xs: '0', sm: '0' }, // rely on gap/padding for spacing
};

const descriptionTextStyle = {
    fontFamily: 'IBM Plex Mono',
    fontWeight: '300',
    fontSize: { xs: '0.85rem', sm: '1.1rem' }, // Smaller font size on mobile
    paddingLeft: { xs: '1rem', sm: '0rem'},
    paddingRight: { xs: '1rem', sm: '0rem'}
};

const descriptionHeadingStyle = {
    fontFamily: 'Oswald',
    marginTop: '1%',
    marginBottom: '3%',
    fontSize: { xs: '1.8rem', sm: '2.4rem' }, // Responsive font size
};

const headingStyle = {
    fontFamily: 'Oswald',
    alignItems: 'center',
    fontSize: { xs: '1.9rem', sm: '3rem' }, // Responsive font size for "PAINT.CREATE.PARTY"
};

const subHeadingStyle = {
    fontFamily: 'IBM Plex Mono',
    fontWeight: '300',
    fontSize: { xs: '0.9rem', sm: '1.3rem' }, // Responsive font size
    alignItems: 'center',
    maxWidth: { xs: '80%', sm: '30%' }, // Adjust width for mobile
    wordWrap: 'break-word',
    textAlign: 'center', // Center-align text on mobile
};

function About() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Detect if screen size is mobile
    
    return (
        <Box sx={aboutParentContainerStyle}>
            {/* Heading Section */}
            <Box sx={headingBoxStyle}>
                <Typography component="h1" sx={headingStyle}>
                    PAINT. CREATE. PARTY.
                </Typography>
                <Typography component="h3" sx={subHeadingStyle}>
                    We have fun here. Visit our locally owned studio for splatter paint sessions, painting classes, various crafts, or book the space for your next event!
                </Typography>
            </Box>

            {/* Content Section */}
            <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                <Box sx={{ ...contentBoxStyle }}>
                    <ImageCarousel />
                    <Box sx={textContainerStyle}>
                        <Typography component="h1" sx={descriptionHeadingStyle}>
                            SPLATTER PAINT
                        </Typography>
                        <Typography sx={descriptionTextStyle}>
                            In the wild room painters can enjoy a fully immersive experience with the freedom to splatter paint their canvas, crafts, and friends from floor to ceiling while covered in fully protective gear.
                            The Wild Room is equipped with black lights and painters can use our neon glow paint and creative tools for a truly unique experience. At the end,
                            you'll be able to take home your very own masterpiece!
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ ...contentBoxStyle }}>
                    <Box sx={textContainerStyle}>
                        <Typography component="h1" sx={descriptionHeadingStyle}>
                            PRIVATE PARTIES
                        </Typography>
                        <Typography sx={descriptionTextStyle}>
                            Wild At Art is the perfect place to host your next event. Our private party room accommodates up to 50 guests, and can be transformed into the space of your dreams. It features seating, fridge, freezer, and warming trays for food.
                            Our one of a kind birthday party packages start at $350. We also offer unique and memorable decor packages including things like backdrops, balloon arches, and more! Our space is perfect for all ages and any gathering you can dream up.
                            <br />
                            <br />
                            We love creating - but our space can do much more than just paint. With or without the art, we'd love to host your next event!
                        </Typography>
                    </Box>
                    <ImageCarousel />
                </Box>

                <Box sx={{ ...contentBoxStyle }}>
                {isMobile ? (
                    <>
                        <Box sx={textContainerStyle}>
                            <Typography component="h1" sx={descriptionHeadingStyle}>
                                PAINT CLASSES
                            </Typography>
                            <Typography sx={descriptionTextStyle}>
                                Join us for a paint class with local artists. Check our Facebook page for info on upcoming paint classes and events. In the past we've done things
                                like coffee painting, sip and paint, paint your partner, and more! We also offer private paint classes for groups of 8 or more.
                            </Typography>
                        </Box>
                        <ImageCarousel />
                    </>
                ) : (
                    <>
                        <ImageCarousel />
                        <Box sx={textContainerStyle}>
                            <Typography component="h1" sx={descriptionHeadingStyle}>
                                PAINT CLASSES
                            </Typography>
                            <Typography sx={descriptionTextStyle}>
                                Join us for a paint class with local artists. Check our Facebook page for info on upcoming paint classes and events. In the past we've done things
                                like coffee painting, sip and paint, paint your partner, and more! We also offer private paint classes for groups of 8 or more.
                            </Typography>
                        </Box>
                    </>
                )}
                </Box>

                <Box sx={{ ...contentBoxStyle }}>
                    <Box sx={textContainerStyle}>
                        <Typography component="h1" sx={descriptionHeadingStyle}>
                            OTHER ACTIVITIES
                        </Typography>
                        <Typography sx={descriptionTextStyle}>
                            We're always offering seasonal events, so be sure to check out our Facebook page for the latest updates! Have an idea or craft you want to
                            make? Just contact us; we're always looking to expand our offerings and try new things. We also offer a variety of crafts, slime making, texture painting, paint pouring, and more!
                        </Typography>
                    </Box>
                    <ImageCarousel />
                </Box>
            </div>
        </Box>
    );
}

export default About;